import { SDKEventAttrs } from '@mparticle/web-sdk';
import {
  mParticleEventType,
  mParticleLogEvent,
  mParticleLogPageView,
} from '@treatwell/ui';

export const trackEvent = (
  eventName: string,
  eventType?: (typeof mParticleEventType)[keyof typeof mParticleEventType],
  eventAttributes?: SDKEventAttrs
) => {
  mParticleLogEvent(
    eventName,
    eventType || mParticleEventType.Other,
    eventAttributes
  );
};

export const trackPageViewEvent = (
  eventName: string,
  eventAttributes: SDKEventAttrs
) => {
  mParticleLogPageView(eventName, eventAttributes);
};
